<template>
  <div class="design-hub">
    <aside class="design-sidebar" :class="{ collapsed: sidebarCollapsed && isCompact }">
      <div class="sidebar-head">
        <h2>产品设计文档</h2>
        <el-button
          v-if="isCompact"
          class="toggle-btn"
          text
          @click="sidebarCollapsed = !sidebarCollapsed"
        >
          {{ sidebarCollapsed ? '目录' : '收起' }}
        </el-button>
      </div>
      <p class="sidebar-hint">源文件在仓库根目录；修改后请运行 <code>scripts/sync-design-docs.sh</code> 同步到本站。</p>
      <ul class="doc-list">
        <li
          v-for="doc in docs"
          :key="doc.id"
          :class="{ active: doc.id === activeId }"
          @click="selectDoc(doc.id)"
        >
          <span class="doc-title">{{ doc.title }}</span>
          <span class="doc-desc">{{ doc.description }}</span>
        </li>
      </ul>
      <a class="open-raw" :href="activeFile" target="_blank" rel="noopener">新窗口打开当前文档</a>
    </aside>

    <main class="design-main">
      <iframe
        v-if="activeFile"
        :key="activeFile"
        class="design-frame"
        :src="activeFile"
        title="产品设计文档"
      />
    </main>
  </div>
</template>

<script>
import { DESIGN_DOCS, findDesignDoc } from '../config/designDocs.js'

const COMPACT_BREAKPOINT = 768

export default {
  name: 'DesignHubView',
  data() {
    return {
      docs: DESIGN_DOCS,
      activeId: 'product',
      sidebarCollapsed: false,
      isCompact: false
    }
  },
  computed: {
    activeDoc() {
      return findDesignDoc(this.activeId)
    },
    activeFile() {
      return this.activeDoc?.file || ''
    }
  },
  watch: {
    '$route.params.docId': {
      immediate: true,
      handler(id) {
        const doc = DESIGN_DOCS.find((d) => d.id === id)
        this.activeId = doc ? doc.id : 'product'
      }
    }
  },
  mounted() {
    this.checkCompact()
    window.addEventListener('resize', this.checkCompact)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkCompact)
  },
  methods: {
    checkCompact() {
      this.isCompact = window.innerWidth < COMPACT_BREAKPOINT
    },
    selectDoc(id) {
      this.activeId = id
      const path = id === 'product' ? '/design' : `/design/${id}`
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
      if (this.isCompact) {
        this.sidebarCollapsed = true
      }
    }
  }
}
</script>

<style scoped>
.design-hub {
  display: flex;
  min-height: calc(100vh - 120px);
  background: #f0f2f5;
}
.design-sidebar {
  width: 280px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #e4e7ec;
  padding: 16px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.design-sidebar.collapsed {
  display: none;
}
.sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.sidebar-head h2 {
  margin: 0;
  font-size: 1.1rem;
  color: #35946a;
}
.sidebar-hint {
  font-size: 12px;
  color: #909399;
  margin: 8px 0 16px;
  line-height: 1.5;
}
.sidebar-hint code {
  font-size: 11px;
  background: #f4f4f5;
  padding: 1px 4px;
  border-radius: 3px;
}
.doc-list {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1;
}
.doc-list li {
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.15s;
}
.doc-list li:hover {
  background: #f5f7fa;
}
.doc-list li.active {
  background: #eef9f3;
  border-color: #42b983;
}
.doc-title {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #303133;
}
.doc-desc {
  display: block;
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}
.open-raw {
  margin-top: 12px;
  font-size: 13px;
  color: #42b983;
  text-decoration: none;
}
.open-raw:hover {
  text-decoration: underline;
}
.design-main {
  flex: 1;
  min-width: 0;
  padding: 0;
}
.design-frame {
  width: 100%;
  height: calc(100vh - 120px);
  border: none;
  background: #fff;
}
@media (max-width: 768px) {
  .design-hub {
    flex-direction: column;
  }
  .design-sidebar {
    width: 100%;
    max-height: 40vh;
  }
  .design-frame {
    height: calc(100vh - 200px);
  }
}
</style>
